<template>
  <section id="comercial" class="comercial">
    <div class="container">
      <div class="row justify-content-center align-items-center">
        <div class="col-lg-6 content-lado" data-aos="fade-right">
          <div class="section-title">
            <h2>Quer levar as soluções Creditall para sua empresa?</h2>
            <p style="font-size: 18px">
              Conte um pouco sobre seu negócio. Nosso time comercial entrará em
              contato para entender sua necessidade e apresentar a solução mais
              adequada.
            </p>
          </div>
        </div>
        <div class="col-lg-6" data-aos="fade-left">
          <LeadForm variant="section" origem="home_secao_comercial" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import LeadForm from './LeadForm.vue';

export default {
  name: 'SectionCaptacaoComercial',
  components: { LeadForm },
};
</script>

<style scoped>
section {
  padding: 60px 0;
  overflow: hidden;
  background: #f7f7f7;
}

.section-title {
  padding: 20px 0 30px;
  position: relative;
}
.section-title h2 {
  font-size: 30px;
  font-weight: 700;
  margin-bottom: 16px;
  color: #191919;
}

@media (max-width: 991px) {
  .content-lado {
    text-align: center;
    margin-bottom: 8px;
  }
  .section-title h2 {
    font-size: 24px;
  }
}
</style>
